<script>
export default {
    name: "Question",
    props: [
        'question_no',
        'active',
        'question_left',
        'question_right',
        'question_answer',
    ],
    data(){
        return {
            checked_state: {
                1: this.question_answer===1,
                2: this.question_answer===2,
                3: this.question_answer===3,
                4: this.question_answer===4,
            }
        }
    },
    methods: {
        /**
         * 回答番号クリック時処理
         * @param question_no 質問番号
         * @param answer_no 回答選択番号
         * @param event クリックイベント
         */
        onClickEvent(question_no, answer_no, event){
            this.checked_state = {
                1: (answer_no===1),
                2: (answer_no===2),
                3: (answer_no===3),
                4: (answer_no===4),
            }
            //親コンポーネントのメソッドを呼び出し
            this.$emit('clickQuestionAnswer', { question_no, answer_no, event })
        }
    }
}
</script>

<template>
    <div :class="{question:true, active:active===true, inactive:active===false}">
        <div class="statement__row">
            <div class="column-2">
                <p>{{ question_left }}</p>
            </div>
            <div class="column-2">
                <p>{{ question_right }}</p>
            </div>
        </div>
        <div class="options__row">
            <div v-for="answer_no in [1,2,3,4]"
                 :key="answer_no"
                 :class="{option:true, checked:checked_state[answer_no]}"
                 @click="onClickEvent(question_no, answer_no, $event)">{{ answer_no }}</div>
        </div>
    </div>
</template>

<style scoped>
.option:hover{
    background-color: #0071BC;
    color: #FFF;
    cursor: pointer;
}
</style>
